import React from 'react';
import { View, } from 'react-native';
import { Interaction } from '@ui-kitten/components';
import { TouchableWeb } from '@ui-kitten/components/devsupport';
import styled from "../../../theming/util/styled";
import util from "../../util";
export var DNACardAppearanceEnum;
(function (DNACardAppearanceEnum) {
    DNACardAppearanceEnum["float"] = "float";
    DNACardAppearanceEnum["outline"] = "outline";
    DNACardAppearanceEnum["flat"] = "flat";
    DNACardAppearanceEnum["meetings"] = "meetings";
})(DNACardAppearanceEnum || (DNACardAppearanceEnum = {}));
export const DNACardAppearanceKeys = Object.keys(DNACardAppearanceEnum);
export var DNACardInteractiveEnum;
(function (DNACardInteractiveEnum) {
    DNACardInteractiveEnum["pressable"] = "pressable";
    DNACardInteractiveEnum["pressableAlt"] = "pressableAlt";
})(DNACardInteractiveEnum || (DNACardInteractiveEnum = {}));
export const DNACardInteractiveKeys = Object.keys(DNACardInteractiveEnum);
function parseThemeStyle(source) {
    const { customAttr, ...container } = source;
    return {
        container,
        customStyle: {
            customAttr,
        },
    };
}
function handleState(eva, interaction, callback) {
    return (event) => {
        eva?.dispatch?.(interaction ? [interaction] : []);
        callback?.(event);
    };
}
export const DNACard = React.forwardRef((props, ref) => {
    const { as, eva, children, style, interactive, onMouseEnter, onMouseLeave, onFocus, onBlur, onPressIn, onPressOut, ...rest } = props;
    const themeStyles = parseThemeStyle(eva.style);
    const containerStyle = util.mergeStyles(props, themeStyles.container);
    return (interactive
        ? <TouchableWeb ref={ref} style={containerStyle} onMouseEnter={handleState(eva, Interaction.HOVER, onMouseEnter)} onMouseLeave={handleState(eva, Interaction.FOCUSED, onMouseLeave)} 
        /** This prop does not appear to exist? */
        // onMouseOver = {handleState(eva, Interaction.HOVER, onMouseEnter)}
        onBlur={handleState(eva, undefined, onBlur)} onPressIn={handleState(eva, Interaction.ACTIVE, onPressIn)} onPressOut={handleState(eva, undefined, onPressIn)} {...rest}>{children}</TouchableWeb>
        : <View ref={ref} style={containerStyle} {...rest}>{children}</View>);
});
export default styled('DNACard')(DNACard);
//# sourceMappingURL=DNACard.js.map